import React, { useState, useEffect, useCallback } from "react";
import styles from "./ContractsList.module.sass";
import cn from "classnames";
import Card from "../../components/Card";
import Form from "../../components/Form";
import Table from "./Table";
import Icon from "../../components/Icon";
import { getCompanyForCurrentUser } from "../../services/company.service";
import { getFoldersByCompanyId } from "../../services/folder.service";
import { pb } from "../../services/pocketbase";

const CompanyContractsList = () => {
  const [search, setSearch] = useState("");
  const [folders, setFolders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [noResults, setNoResults] = useState(false);

  const fetchFolders = useCallback(async () => {
    setLoading(true);
    setError(null);
    setNoResults(false);

    try {
      const company = await getCompanyForCurrentUser();
      
      if (company?.id) {
        const companyFolders = await getFoldersByCompanyId(company.id);
        
        // Filtrer par recherche si nécessaire
        let filteredFolders = companyFolders || [];
        if (search.trim()) {
          const searchLower = search.toLowerCase();
          filteredFolders = filteredFolders.filter(folder => {
            const student = folder.expand?.student_id;
            const studentName = `${student?.first_name || ''} ${student?.last_name || ''}`.toLowerCase();
            return studentName.includes(searchLower);
          });
        }
        
        setFolders(filteredFolders);
        setNoResults(filteredFolders.length === 0 && !!search);
      }
    } catch (err) {
      console.error("Erreur lors de la récupération des dossiers:", err);
      setError("Impossible de charger les contrats. Veuillez réessayer.");
      setFolders([]);
    } finally {
      setLoading(false);
    }
  }, [search]);

  useEffect(() => {
    fetchFolders();

    // Listener temps réel
    pb.collection('folders').subscribe('*', () => fetchFolders());

    return () => {
      pb.collection('folders').unsubscribe();
    };
  }, [fetchFolders]);

  const handleSubmit = (e) => {
    e?.preventDefault();
    fetchFolders();
  };

  const handleSearchChange = (value) => {
    setSearch(value);
  };

  return (
    <Card
      className={styles.card}
      title="Contrats"
      classTitle={cn("title-yellow", styles.title)}
      classCardHead={styles.head}
      head={
        <Form
          className={styles.form}
          value={search}
          setValue={handleSearchChange}
          onSubmit={handleSubmit}
          placeholder="Rechercher par nom d'apprenti"
          type="text"
          name="search"
          icon="search"
        />
      }
    >
      {error && <div className={styles.error}>{error}</div>}
      
      {loading ? (
        <div className={styles.loading}>Chargement des contrats...</div>
      ) : (
        <div className={styles.row}>
          {noResults && folders.length === 0 && (
            <div className={styles.empty}>
              <p>Aucun contrat trouvé pour votre recherche "{search}".</p>
            </div>
          )}
          {!noResults && folders.length === 0 && !loading && !error && (
            <div className={styles.empty}>
              <p>Aucun contrat d'alternance disponible.</p>
            </div>
          )}
          {folders.length > 0 && (
            <Table
              className={styles.table}
              items={folders}
            />
          )}
        </div>
      )}
    </Card>
  );
};

export default CompanyContractsList;
